import * as React from 'react';
import { Layout, Row } from 'antd';
import styled from 'styled-components';
import ScreenHelper from '../../components/Styled/ScreenHelper';

const { Header, Content, Footer } = Layout;

export const ImportantInfo = styled.div`
    font-size: "1em";
  ${ScreenHelper.down('md')`
      margin-right: 10px;
      margin-left: 5px;
  `};

  ${ScreenHelper.down('sm')`
  margin-right: 100px;
  margin-left: 5px;
`}
`;
